import { render, staticRenderFns } from "./State.vue?vue&type=template&id=815f247e&"
import script from "./State.vue?vue&type=script&lang=js&"
export * from "./State.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports